<template>
  <div v-if="show_footer" class="bg-primary">
    <b-container fluid>
      <b-row class="align-items-center my-5">
        <b-col
          class="d-flex justify-content-center mt-5 mt-xl-0"
          cols="12"
          lg="4"
          order="2"
          order-lg="0"
        >
          <b-link href="/" style="width: 15%">
            <img
              src="./../assets/synaplus_logo_square_white.svg"
              alt="Synaplus"
            />
          </b-link>

          <div
            class="d-flex flex-column justify-content-center text-white text-left ml-4"
          >
            <h4 class="m-0">
              Synaplus
            </h4>
            <div class="font-alt">
              Enlighten your world
            </div>
          </div>
        </b-col>

        <b-col
          class="d-flex flex-column "
          align="center"
          cols="12"
          lg="4"
          order="0"
          order-lg="1"
        >
          <div>
            <a
              target="_blank"
              href="https://www.youtube.com/channel/UCgVyDQWjLffp3yNLWtyq79A"
              class="fab fa-youtube text-white fa-2x mx-4"
            />
            <a
              target="_blank"
              href="https://twitter.com/synaplus?lang=fr"
              class="fab fa-twitter text-white fa-2x mx-4"
            />
            <a
              target="_blank"
              href="https://www.linkedin.com/company/synaplus-solutions?originalSubdomain=fr"
              class="fab fa-linkedin-in text-white fa-2x mx-4"
            />
            <a
              target="_blank"
              href="https://www.facebook.com/synaplus/"
              class="fab fa-facebook-f text-white fa-2x mx-4"
            />
          </div>
        </b-col>

        <b-col
          class="mt-5 mt-xl-0"
          align="center"
          cols="12"
          lg="4"
          order="1"
          order-lg="2"
        >
          <a
            class="text-white font-alt"
            href="mailto:contact@synaplus.com?Subject=Faisant%20suite%20à%20la%20consultation%20de%20votre%20site%20web..."
            target="_top"
            >contact@synaplus.com</a
          >
        </b-col>
      </b-row>
    </b-container>
    <b-container fluid>
      <b-row class="justify-content-center">
        <div class="text-white text-alt mt-auto">
          © Synaplus 2021. All rights reserved
        </div>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'PageFooter',
  computed: mapState(['show_footer']),
}
</script>
